// Remove loading class from all already loaded images
function removeLoadingClassFromLoadedImages(container) {
  container.querySelectorAll('img').forEach((el) => {
    if (el.complete) {
      el.parentNode.classList.remove('loading-shimmer');
    }
  });
}

// Remove loading class from image on `load` event
function handleImageLoaded(el) {
  if (el.tagName == 'IMG' && el.parentNode.classList.contains('loading-shimmer')) {
    el.parentNode.classList.remove('loading-shimmer');
  }
}

export {removeLoadingClassFromLoadedImages, handleImageLoaded};
